const KEY_CODES = {
  SPACE: 'Space'
};

export { KEY_CODES };
